"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgOpenBookFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M12.5 7.494s0-1.817 6.495-1.987A.985.985 0 0120 6.494v8c0 .552-.45.997-1 1.027-4.334.24-6.5 1.973-6.5 1.973v-10zM4 6.494a.981.981 0 011.004-.986c5.133.154 6.232 1.478 6.447 1.874a.483.483 0 01.049.235v9.877S9.333 15.76 5 15.52c-.55-.03-1-.475-1-1.027v-8z' }),
    react_1.default.createElement("path", { d: 'M2 8.494a1 1 0 011-1v6.639c0 1.236 1.117 2.192 2.352 2.201 1.91.014 4.471.395 5.648 2.16H3a1 1 0 01-1-1v-9zM22 8.494a1 1 0 00-1-1v6.639c0 1.236-1.117 2.192-2.352 2.201-1.91.014-4.471.395-5.648 2.16h8a1 1 0 001-1v-9z' }))); };
exports.default = SvgOpenBookFilled;
//# sourceMappingURL=OpenBookFilled.js.map